import React from 'react';
import { ErrorMessage } from '../app/utils';
import { Box, SxProps, Tooltip, TooltipProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ErrorIcon } from './icons';

type Props = {
  errorMessage: ErrorMessage;
  color: string;
  placement?: TooltipProps['placement'];
  sx?: SxProps;
};

/**
 * Displays an Error indicator with message
 * @param errorMessage
 * @param color
 * @param placement
 * @param sx
 * @constructor
 */
const ErrorIndicator = ({ errorMessage, color, placement, sx }: Props) => {
  const { t } = useTranslation();
  return (
    <Tooltip
      title={t(errorMessage.stringKey, errorMessage.props) as any}
      placement={placement}
    >
      <Box sx={sx} display={'flex'}>
        <ErrorIcon color={color} />
      </Box>
    </Tooltip>
  );
};

export default ErrorIndicator;
